/* RAVENSCROFT — global.js */
(function () {
  "use strict";
  var RC = window.RC || {};

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var amount = (cents / 100);
    var fmt = RC.moneyFormat || "${{amount}}";
    var str = amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, str)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toLocaleString("en-US"));
  }

  /* ---------- header scroll ---------- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- scroll lock ---------- */
  function lock() { document.documentElement.style.overflow = "hidden"; }
  function unlock() { document.documentElement.style.overflow = ""; }

  /* ---------- mobile nav ---------- */
  var mnav = document.querySelector("[data-mobile-nav]");
  function openNav() { if (!mnav) return; mnav.classList.add("is-open"); mnav.setAttribute("aria-hidden", "false"); lock(); }
  function closeNav() { if (!mnav) return; mnav.classList.remove("is-open"); mnav.setAttribute("aria-hidden", "true"); unlock(); }
  document.querySelectorAll("[data-menu-open]").forEach(function (b) { b.addEventListener("click", openNav); });
  document.querySelectorAll("[data-menu-close]").forEach(function (b) { b.addEventListener("click", closeNav); });

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector("[data-cart-drawer]");
  var overlay = document.querySelector("[data-overlay]");
  var useDrawer = RC.cartType === "drawer" && drawer;

  function openCart() {
    if (!useDrawer) { window.location.href = "/cart"; return; }
    refreshCart().then(function () {
      drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false");
      if (overlay) overlay.classList.add("is-open");
      lock();
    });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true");
    if (overlay) overlay.classList.remove("is-open");
    unlock();
  }
  document.querySelectorAll("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCart); });
  if (overlay) overlay.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); closeNav(); } });

  function updateCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
    });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!useDrawer) return;
    var body = drawer.querySelector("[data-cart-body]");
    var foot = drawer.querySelector("[data-cart-foot]");
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a class="link-underline" href="/collections/all">Browse the catalog</a></div>';
      if (foot) foot.setAttribute("hidden", "");
      return;
    }
    var html = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="">' : "";
      var variant = (it.product_has_only_default_variant) ? "" : '<div class="cart-item__variant">' + it.variant_title + "</div>";
      return '<div class="cart-item" data-key="' + it.key + '">' +
        '<div class="cart-item__img">' + img + "</div>" +
        '<div><div class="cart-item__title">' + it.product_title + "</div>" + variant +
        '<div class="cart-item__variant">' + formatMoney(it.final_price) + " &times; " + it.quantity + "</div>" +
        '<button class="cart-item__remove" data-remove="' + it.key + '">Remove</button></div>' +
        '<div class="price" style="font-size:.95rem">' + formatMoney(it.final_line_price) + "</div>" +
        "</div>";
    }).join("");
    body.innerHTML = html;
    if (foot) { foot.removeAttribute("hidden"); drawer.querySelector("[data-cart-total]").textContent = formatMoney(cart.total_price); }
    body.querySelectorAll("[data-remove]").forEach(function (b) {
      b.addEventListener("click", function () { changeItem(b.getAttribute("data-remove"), 0); });
    });
  }

  function refreshCart() {
    return fetch(RC.routes.cart).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }
  function changeItem(key, qty) {
    return fetch(RC.routes.cart_change, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }

  /* add to cart via product forms */
  document.querySelectorAll("form[action*='/cart/add'], form[data-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : "";
      if (btn) { btn.classList.add("is-disabled"); btn.textContent = "Adding…"; }
      fetch(RC.routes.cart_add, { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { // error
            if (btn) btn.textContent = res.description || "Unavailable";
            setTimeout(function () { if (btn) { btn.classList.remove("is-disabled"); btn.textContent = original; } }, 1800);
            return;
          }
          if (btn) { btn.textContent = "Added ✓"; }
          refreshCart().then(function () { openCart(); });
          setTimeout(function () { if (btn) { btn.classList.remove("is-disabled"); btn.textContent = original; } }, 1400);
        })
        .catch(function () { if (btn) { btn.classList.remove("is-disabled"); btn.textContent = original; } });
    });
  });

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = parseInt(input.value, 10) || 1;
        v += b.getAttribute("data-step") === "up" ? 1 : -1;
        if (v < 1) v = 1;
        input.value = v;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* ---------- product gallery ---------- */
  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var main = gallery.querySelector("[data-gallery-main] img");
    gallery.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (main) { main.src = t.getAttribute("data-full"); main.alt = t.querySelector("img") ? t.querySelector("img").alt : ""; }
        gallery.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* ---------- variant selector ---------- */
  var variantRoot = document.querySelector("[data-variants]");
  if (variantRoot) {
    var data = JSON.parse(variantRoot.getAttribute("data-variants") || "[]");
    var selected = {};
    var idInput = document.querySelector("[data-variant-id]");
    var priceEl = document.querySelector("[data-variant-price]");
    var addBtn = document.querySelector("[data-add-btn]");

    variantRoot.querySelectorAll("[data-opt-pos]").forEach(function (grp) {
      var pos = grp.getAttribute("data-opt-pos");
      var first = grp.querySelector(".variant__btn.is-active");
      if (first) selected[pos] = first.getAttribute("data-value");
      grp.querySelectorAll(".variant__btn").forEach(function (b) {
        b.addEventListener("click", function () {
          grp.querySelectorAll(".variant__btn").forEach(function (x) { x.classList.remove("is-active"); });
          b.classList.add("is-active");
          selected[pos] = b.getAttribute("data-value");
          resolveVariant();
        });
      });
    });

    function resolveVariant() {
      var match = data.find(function (v) {
        return (!selected["1"] || v.option1 === selected["1"]) &&
               (!selected["2"] || v.option2 === selected["2"]) &&
               (!selected["3"] || v.option3 === selected["3"]);
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
        ? "<del>" + formatMoney(match.compare_at_price) + "</del> " + formatMoney(match.price)
        : formatMoney(match.price);
      if (addBtn) {
        if (match.available) { addBtn.classList.remove("is-disabled"); addBtn.textContent = addBtn.getAttribute("data-label") || "Add to bag"; }
        else { addBtn.classList.add("is-disabled"); addBtn.textContent = "Sold out"; }
      }
    }
    resolveVariant();
  }

  /* ---------- reveal on scroll ---------- */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if (revealEls.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---------- marquee seamless loop ---------- */
  document.querySelectorAll(".marquee__track").forEach(function (track) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });
})();
